import React from 'react';

const Loading = ({
  size = 'md',
  text = '',
  fullScreen = false,
  variant = 'spinner',
}) => {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
    xl: 'w-14 h-14',
  };

  const Spinner = () => (
    <svg
      className={`animate-spin ${sizes[size]} text-primary-500`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
      <path
        className="opacity-80"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );

  const Dots = () => (
    <div className="flex items-center gap-1.5">
      {[0, 150, 300].map((delay) => (
        <div
          key={delay}
          className={`${sizes[size]} bg-primary-500 rounded-full animate-bounce`}
          style={{ animationDelay: `${delay}ms` }}
        />
      ))}
    </div>
  );

  const Pulse = () => (
    <div className="relative flex items-center justify-center">
      <div className={`${sizes[size]} bg-primary-400/40 rounded-full animate-ping absolute`} />
      <div className={`${sizes[size]} bg-primary-500 rounded-full`} />
    </div>
  );

  const indicators = { spinner: <Spinner />, dots: <Dots />, pulse: <Pulse /> };

  const content = (
    <div className="flex flex-col items-center justify-center gap-3">
      {indicators[variant] || <Spinner />}
      {text && (
        <p className="text-sm font-medium text-slate-500 dark:text-slate-400 animate-pulse">
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white/80 dark:bg-slate-950/80 backdrop-blur-sm flex items-center justify-center z-50">
        {content}
      </div>
    );
  }

  return content;
};

export default Loading;
